const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

let onUnauthorized = null;

export function setOnUnauthorized(callback) {
    onUnauthorized = callback;
}

// authFetch — универсальная обёртка над fetch
// options.headers дополняются токеном, если есть
export async function authFetch(endpoint, options = {}) {
    const token = localStorage.getItem('token');

    // Добавим заголовки
    const headers = options.headers || {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';

    const newOptions = {
        ...options,
        headers
    };

    const response = await fetch(`${API_URL}${endpoint}`, newOptions);

    // Если сервер вернул 401, вызываем сохранённый колбэк
    if (response.status === 401 && onUnauthorized) {
        // Проверим, не /auth/login ли это
        if (!endpoint.includes('/auth/login')) {
            onUnauthorized();
        }
    }

    return response;
}

// Регистрация
export async function registerUser(username, password) {
    const response = await authFetch(`/auth/register`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({username, password})
    });
    return response.json();
}

// Логин
export async function loginUser(username, password) {
    const response = await authFetch(`/auth/login`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({username, password})
    });
    return response.json();
}

// Список товаров (с фильтрацией/сортировкой)
export async function getItems(params = {}) {
    let query = new URLSearchParams(params).toString();
    const response = await authFetch(`/catalog/?${query}`);
    return response.json();
}

// Получить корзину
export async function getCart(token) {
    const response = await authFetch(`/cart/`, {
        headers: {'Authorization': `Bearer ${token}`}
    });
    return response.json();
}

// Добавить товар в корзину
export async function addToCart(token, item_id, quantity = 1) {
    const response = await authFetch(`/cart/add`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({item_id, quantity})
    });
    return response.json();
}

// Удалить товар из корзины
export async function removeFromCart(token, item_id) {
    const response = await authFetch(`/cart/remove`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({item_id})
    });
    return response.json();
}

// Оформить заказ
export async function createOrder(token) {
    const response = await authFetch(`/orders/`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    return response.json();
}

// Получить данные заказа
export async function getOrder(token, orderId) {
    const response = await authFetch(`/orders/${orderId}`, {
        headers: {'Authorization': `Bearer ${token}`}
    });
    return response.json();
}
